function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import AccordionItem from './accordion-item';
import FontItem from './font-item';
import MerchantLogo from './merchant-logo';
import React from 'react';
import ShapeItem from './shape-item';
import StylingItem from './styling-item';

var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);

  var _super = _createSuper(Accordion);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _super.call(this, props);
    _this.state = {
      selectedItem: undefined
    };
    return _this;
  }

  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          supportedFeatures = _this$props.supportedFeatures,
          wpfCustomThemeV2 = _this$props.wpfCustomThemeV2,
          options = _this$props.options;
      var fonts = options.fonts,
          shapes = options.shapes,
          logoSizes = options.logoSizes,
          merchantLogo = options.merchantLogo;
      return React.createElement("ul", {
        className: "accordion"
      }, React.createElement(AccordionItem, {
        title: I18n.t('javascript.v2.wpf_custom_theme.styling.title'),
        active: this.state.selectedItem === '1',
        onToggle: function onToggle() {
          return _this2.toggle('1');
        }
      }, React.createElement(MerchantLogo, {
        details: {
          merchantLogo: merchantLogo,
          size: wpfCustomThemeV2.logo_size,
          sizes: logoSizes
        },
        supportedFeatures: supportedFeatures,
        onStyleChange: function onStyleChange(name, value) {
          return _this2.props.onStyleChange(name, value);
        },
        onUpdateWpfUiStateSupportedFeatureValue: function onUpdateWpfUiStateSupportedFeatureValue(feature, value) {
          return _this2.props.onUpdateWpfUiStateSupportedFeatureValue(feature, value);
        },
        onUpdateSupportedFeature: function onUpdateSupportedFeature(feature, value) {
          return _this2.props.onUpdateSupportedFeature(feature, value);
        }
      }), React.createElement(StylingItem, {
        onThemeChange: function onThemeChange(theme) {
          return _this2.props.onThemeChange(theme);
        },
        selectedTheme: wpfCustomThemeV2.theme,
        onStyleChange: function onStyleChange(name, value) {
          return _this2.props.onStyleChange(name, value);
        },
        brandColor: wpfCustomThemeV2.brand_color,
        background: wpfCustomThemeV2.background,
        layoutOption: wpfCustomThemeV2.layout_option,
        backgroundImageFlag: wpfCustomThemeV2.background_image_flag
      }), React.createElement(FontItem, {
        fonts: fonts,
        fontFamily: wpfCustomThemeV2.font_family,
        onStyleChange: function onStyleChange(name, value) {
          return _this2.props.onStyleChange(name, value);
        }
      }), React.createElement(ShapeItem, {
        input: _objectSpread(_objectSpread({}, shapes.input), {}, {
          size: wpfCustomThemeV2.input_size
        }),
        border: _objectSpread(_objectSpread({}, shapes.border), {}, {
          radius: wpfCustomThemeV2.border_radius
        }),
        onStyleChange: function onStyleChange(name, value) {
          return _this2.props.onStyleChange(name, value);
        }
      })));
    }
  }, {
    key: "toggle",
    value: function toggle(item) {
      if (this.state.selectedItem === item) {
        return this.setState({
          selectedItem: undefined
        });
      }

      this.setState({
        selectedItem: item
      });
    }
  }]);

  return Accordion;
}(React.Component);

export default Accordion;